export const WOWSMART_ALLOWED_ACCOUNTS = ['87116550'];

export function isWowSmartAllowed(user) {
  if (!user) return false;
  const keys = [user.accountNumber, user.account_number, user.id, user.username]
    .map((v) => String(v ?? '').trim())
    .filter(Boolean);
  return keys.some((k) => WOWSMART_ALLOWED_ACCOUNTS.includes(k));
}
